import isArray from 'lodash/isArray';
import union from 'lodash/union';

export default class User {

	constructor(acl, roles = []) {
		this.acl = acl;
		this.addRole(roles);
	}

	makeArray(item) {
		if (!item) {
			return [];
		}
		return isArray(item) ? item : [item];
	};

	addRole(roles) {
		roles = this.makeArray(roles);
		this.roles = union(this.roles, roles);
	}

	setRole(roles) {
		this.roles = this.makeArray(roles);
	}

	setAcl(acl) {
		this.acl = acl;
	}

	isAllowed(resources, permission) {
		return this.acl.isAllowed(this.roles, resources, permission);
	};
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-acl/src/User.js